module.exports = __webpack_public_path__ + "img/4.13582da6.png";